import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
// @mui
import { Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BannerForm } from '../sections/banner_action';
// sections

// ------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    width: '60vw',
    minWidth: 320,
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(4, 0),
}));

// ---------------------------------------------------------------------

export default function BannerAction() {
    const { id } = useParams();
    const isEditMode = !!id;

    return (
        <>
            <Helmet>
                <title> {!isEditMode ? 'Create' : 'Edit'} Banner | Trooper</title>
            </Helmet>

            <Container>
                <Typography variant="h4" gutterBottom>
                    {!isEditMode ? 'Create' : 'Edit'} Banner
                </Typography>

                <StyledContent>
                    <BannerForm edit={isEditMode} />
                </StyledContent>
            </Container>
        </>
    );
}
